import { gql } from '@apollo/client';

export const OBTENER_PAGINADO_NOTIFICACIONES = gql`
  query ($pagina: Int, $activo: Boolean) {
    notificaciones {
      obtenerNotificaciones(pagina: $pagina, activo: $activo) {
        id
        fechaCreacion
        tipoNotificacion
        data
      }
      obtenerNumNotificaciones(activo: $activo)
    }
  }
`;

export const OBTENER_TOTAL_NUM_NOTIFICACIONES = gql`
  query ($activo: Boolean) {
    notificaciones {
      obtenerNumNotificaciones(activo: $activo)
    }
  }
`;
